<template>
  <v-app>
    <div
      v-if="showPendingRequestWarning"
      class="d-flex justify-center service-unavailable-warning"
    >
      <v-alert
        :value="true"
        type="warning"
        :icon="warningIcon"
        dismissible
        class="core-element-info-message"
        @input="setShowPendingRequestWarning(false)"
      >
        <div class="warning-title">
          {{ $t('pendingRequests.serviceIsTemporaryUnavailable') }}
        </div>
        <div>
          {{ $t('pendingRequests.theRequestHasOccurredButTheDataWillBeUpdatedWhenTheServerIsAvailable') }}
        </div>
        <div>{{ $t('pendingRequests.ifTheDataDidntUpdateTryToSendRequestAgainOrContactYourAccountManager') }}</div>
      </v-alert>
    </div>
    <router-view />
  </v-app>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import {
  DATA_LAYER_EVENTS,
  DATA_LAYER_INTERCOM_FIELDS,
  DATA_LAYER_USER_FIELDS
} from '@/constants/dataLayer'
import { EXCLAMATION_ICON, ROLE_NAME } from '@/constants/app'
import { pushToDataLayer } from '@/utils/dataLayer'
import { clearIntercomCookies } from '@/utils/intercom'

export default {
  data () {
    return {
      warningIcon: EXCLAMATION_ICON,
      intercomReady: false,
      lastTrackedUser: null
    }
  },
  computed: {
    ...mapState('pendingRequests', ['showPendingRequestWarning']),
    ...mapState('login', ['authenticationPending']),
    ...mapState('client', ['clients']),
    client () {
      return this.clients.my
    },
    trackedUser () {
      return `${this.client?.fullName}|${this.client?.email}`
    },
    intercomTrackingState () {
      return `${this.trackedUser}|${this.authenticationPending}|${Boolean(this.$route.query.token)}`
    }
  },
  watch: {
    intercomTrackingState: {
      immediate: true,
      handler () {
        this.trackUser()
      }
    }
  },
  mounted () {
    this.setRole(localStorage.getItem(ROLE_NAME))
  },
  methods: {
    ...mapMutations('pendingRequests', ['setShowPendingRequestWarning']),
    ...mapMutations('login', ['setRole']),
    trackUser () {
      if (this.authenticationPending || this.$route?.query?.token) {
        return
      }

      const userName = this.client?.fullName || null
      const userEmail = this.client?.email || null

      if (!this.intercomReady) {
        if (userEmail) {
          clearIntercomCookies()
        }
        this.intercomReady = true
        pushToDataLayer({
          event: DATA_LAYER_EVENTS.CLIENT_ZONE_INTERCOM_READY,
          [DATA_LAYER_INTERCOM_FIELDS.AUTHENTICATED]: Boolean(userEmail),
          [DATA_LAYER_USER_FIELDS.USER_NAME]: userName,
          [DATA_LAYER_USER_FIELDS.USER_EMAIL]: userEmail
        })
      }

      if (!userEmail) {
        this.lastTrackedUser = null
        return
      }

      if (this.lastTrackedUser === this.trackedUser) {
        return
      }

      this.lastTrackedUser = this.trackedUser
      const payload = {
        event: DATA_LAYER_EVENTS.CLIENT_ZONE_USER_LOADED,
        [DATA_LAYER_USER_FIELDS.USER_NAME]: userName,
        [DATA_LAYER_USER_FIELDS.USER_EMAIL]: userEmail
      }
      pushToDataLayer(payload)
    }
  }
}
</script>

<style scoped>
.service-unavailable-warning {
  padding-top: 64px;
  text-align: center;
  position: fixed;
  width: 100%;
  z-index: 1000;
}
.warning-title {
  font-weight: bold;
}
</style>
